
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'CompanyLabel',
})
export default class CompanyLabel extends Vue {}
